import { GetLocalDelegacao, GetLocalkeycloakToken, GetAuthAlternativo } from '@/localStorage'
import { DeleteLocalDelegacao, DeleteLocalIdTokenParsed, DeleteLocalkeycloakToken, DeleteLocalUserInfo, GetLocalIdTokenParsed } from '@/localStorage';
import axios from 'axios'

export const Api = axios.create({
   baseURL: `${process.env.VUE_APP_API}`
})

Api.interceptors.response.use(
   (response) => response,
   (error) => {      
     if (error.response && error.response.status === 401) {
      DeleteLocalDelegacao()
      DeleteLocalIdTokenParsed()
      DeleteLocalkeycloakToken()
      DeleteLocalUserInfo()
               
      localStorage.setItem('logout', 'true')
      let urlRedirect = `${window.location.protocol}//${window.location.host}`
      window.location.href = urlRedirect
     }
     return Promise.reject(error);
   }
 );

export const Config = (params) => {
   let token = ''

   let authAlternativo = GetAuthAlternativo()
   if (authAlternativo.email !== null) {
      token = ''
   } else {
      token = 'Bearer ' + GetLocalkeycloakToken()
   }

   let config = {
      headers: {
         Authorization: token,
         TenantId: `${process.env.VUE_APP_TENANTID}`,
         Delegacao: `${GetLocalDelegacao()}`,
         EmailAuth: `${authAlternativo.email}`,
         TokenAuth: `${authAlternativo.token}`,
         'Content-Type': 'application/json'
      },
      params: params
   }

   return config
}
